import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Login from '@/views/Login'

import { registerPageModule } from '@/utils/store'
import DrsTariffs from '@/store/modules/drs/tariffs.module'
import DrsStore from '@/store/modules/drs/drs.module'

import Promotions from '@/views/Promotions.vue'

Vue.use(Router)

// Turn off the console error when the same route is clicked
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export const router = new Router({
    count: 0,
    mode: 'history',
    base: process.env.BASE_URL,
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            alias: '/privacy-policy',
            name: 'Home',
            title: 'Login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            title: 'Dashboard',
            meta: { requiresAuth: true },
            component: () => import('../views/Dashboard.vue')
        },
        {
            path: '/login',
            name: 'login',
            title: 'Login',
            meta: {
                description:
                    'Panel Detalisty EuroPlatform to narzędzie do zarządzania ofertą promocyjną w Twoim sklepie. Chcesz zarabiać więcej? Dołącz do nas już dziś!'
            },
            component: () => import('../views/Login.vue')
        },
        {
            path: '/pass-reset',
            alias: '/pass-new',
            name: 'pass-reset',
            title: 'Pass Reset',
            component: () => import('../views/PassReset.vue')
        },
        {
            path: '/logout',
            name: 'logout',
            component: () => import('../views/Login.vue')
        },
        {
            path: '/promo-list',
            title: 'Promotions',
            meta: { requiresAuth: true, moduleName: 'promotions' },
            component: Promotions,
            children: [
                {
                    path: '',
                    name: 'promo-list',
                    title: 'Promo List',
                    meta: { requiresAuth: true, moduleName: 'promotions' }
                },
                {
                    path: 'promo-yours',
                    name: 'promo-yours',
                    title: 'Promo Yours',
                    meta: { requiresAuth: true, moduleName: 'promotions' }
                },
                {
                    path: 'promo-later',
                    name: 'promo-later',
                    title: 'Promo Later',
                    meta: { requiresAuth: true, moduleName: 'promotions' }
                },
                {
                    path: 'promo-finished',
                    name: 'promo-finished',
                    title: 'Promo Finished',
                    meta: { requiresAuth: true, moduleName: 'promotions' }
                }
            ]
        },
        {
            path: '/promo-details/:id',
            name: 'promo-details',
            title: 'Promo Details',
            meta: { requiresAuth: true, moduleName: 'promotion' },
            beforeEnter: (to, from, next) => {
                router.options.previous = from
                next()
            },
            component: () => import('../views/Promotion.vue')
        },
        {
            path: '/product-eans',
            name: 'product-eans',
            title: 'Product Eans',
            meta: { requiresAuth: true, moduleName: 'productEans' },
            beforeEnter: (to, from, next) =>
                checkPermission(next, !store.getters.isProductEansPermission),
            component: () => import('../views/ProductEans.vue')
        },
        {
            path: '/labels/',
            name: 'labels',
            title: 'Labels',
            meta: { requiresAuth: true },
            component: () => import('../views/Labels.vue')
        },
        {
            path: '/settings/',
            name: 'settings',
            title: 'Settings',
            meta: { requiresAuth: true },
            component: () => import('../views/Settings.vue'),
            children: [
                {
                    path: 'user_consents',
                    name: 'user-consents',
                    title: 'User Consents',
                    meta: { requiresAuth: true },
                    component: () =>
                        import('../views/settings/UserConsents.vue')
                },
                {
                    path: 'user-stores',
                    name: 'user-stores',
                    title: 'User Stores',
                    meta: { requiresAuth: true },
                    component: () => import('../views/settings/UserStores.vue')
                },
                {
                    path: 'user-networks',
                    name: 'user-networks',
                    title: 'User Networks',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) =>
                        checkPermission(next, true, 'settings.userNetworks'),
                    component: () =>
                        import('../views/settings/UserStoresInNetwork.vue')
                },
                {
                    path: 'documents',
                    name: 'documents',
                    title: 'Documents',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) =>
                        checkPermission(next, true),
                    component: () => import('../views/Documents.vue')
                },
                {
                    path: 'store-users',
                    name: 'store-users',
                    title: 'Store Users Management',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) =>
                        checkPermission(next, true),
                    component: () =>
                        import('../views/settings/StoreUsersManagement')
                },
                {
                    path: 'add-store-user',
                    name: 'add-store-user',
                    title: 'Add Store User',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) =>
                        checkPermission(next, true),
                    component: () => import('../views/settings/AddStoreUser')
                },
                {
                    path: 'notifications',
                    name: 'settings-notifications',
                    title: 'Notifications',
                    meta: { requiresAuth: true },
                    component: () => import('../views/settings/Notifications')
                }
            ]
        },
        {
            path: '/services',
            name: 'services',
            title: 'Services',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/Services.vue')
        },
        {
            path: '/cash-amount/',
            name: 'cashAmount',
            title: 'Cash Amount',
            meta: { requiresAuth: true },
            component: () => import('../views/CashAmount.vue')
        },
        {
            path: '/settlements/',
            name: 'settlements',
            title: 'Settlements',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/Settlements.vue')
        },
        {
            path: '/service/:id',
            name: 'service',
            title: 'Service',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/Service.vue')
        },
        {
            path: '/reports/',
            name: 'reports',
            title: 'Reports',
            meta: { requiresAuth: true },
            component: () => import('../views/Reports.vue')
        },
        {
            path: '/reports/promo_completions',
            name: 'promoCompletions',
            title: 'Promo Completions',
            meta: { requiresAuth: true, moduleName: 'promoRealizations' },
            component: () => import('../views/reports/PromoRealizations.vue')
        },
        {
            path: '/reports/promo_usage',
            name: 'promoUsage',
            title: 'Promo Usage',
            meta: { requiresAuth: true },
            component: () => import('../views/reports/PromoUsage.vue')
        },
        {
            path: '/reports/diagnostics',
            name: 'diagnostics',
            title: 'Diagnostics',
            meta: { requiresAuth: true },
            component: () => import('../views/reports/Diagnostics.vue')
        },
        // temporary disabled
        // {
        //     path: '/reports/promo_plan',
        //     name: 'reportPromoPlan',
        //     title: 'Report Promo Plan',
        //     meta: { requiresAuth: true, moduleName: 'promoPlan' },
        //     component: () => import('../views/reports/PromoPlan.vue')
        // },
        {
            path: '/reports/promo_clearings',
            name: 'reportBillings',
            title: 'Report Billings',
            meta: { requiresAuth: true, moduleName: 'promoBillings' },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/reports/Billings.vue')
        },
        // TODO: Temporarily hidden due to #2302
        // {
        //     path: '/reports/achievement_of_sale_goals',
        //     name: 'saleGoals',
        //     title: 'Sale Goals',
        //     meta: { requiresAuth: true },
        //     beforeEnter: (to, from, next) =>
        //         checkPermission(next, true),
        //     component: () => import('../views/reports/SaleGoals.vue')
        // },
        {
            path: '/reports/mkasa',
            name: 'mKasa',
            title: 'Mkasa',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) =>
                checkPermission(next, false, 'reports.mKasa'),
            component: () => import('../views/reports/MKasa.vue')
        },
        {
            path: '/reports/invalid_usage_products',
            name: 'invalidUsageProducts',
            title: 'Invalid Usage Products',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) =>
                checkPermission(next, true, 'reports.invalidUsageProducts'),
            component: () => import('../views/reports/InvalidUsageProducts.vue')
        },
        {
            path: '/reports/lottery_usage',
            name: 'lotteryUsage',
            title: 'Lottery Usage',
            meta: { requiresAuth: true },
            component: () => import('../views/reports/LotteryUsage.vue')
        },
        {
            path: '/reports/target',
            name: 'targetowka',
            title: 'Targetowka',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/reports/Targetowka.vue')
        },
        {
            path: '/reports/my_shop',
            name: 'myShop',
            title: 'My Shop',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/reports/MyShop.vue')
        },
        {
            path: '/statistics/sale_trend',
            name: 'saleTrend',
            title: 'Sale Trend',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, true),
            component: () => import('../views/statistics/SaleTrend.vue')
        },
        {
            path: '/statistics/top_sale',
            name: 'topSale',
            title: 'Top Sale',
            meta: { requiresAuth: true },
            component: () => import('../views/statistics/TopTen.vue')
        },
        {
            path: '/notifications',
            name: 'notifications',
            title: 'Notifications',
            meta: { requiresAuth: true },
            component: () => import('../views/Notifications.vue')
        },
        {
            path: '/link/:id',
            name: 'link',
            title: 'Link',
            meta: { requiresAuth: false },
            component: () => import('../views/Link.vue')
        },
        {
            path: '/permission-denied',
            name: 'permission-denied',
            title: 'permission-denied',
            component: () => import('../views/PermissionDenied.vue')
        },
        {
            path: '/add-new-promo',
            name: 'add-new-promo',
            title: 'Add new promo',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) =>
                checkPermission(next, !store.getters.isOwnPromoPermission),
            component: () => import('../views/AddNewPromo.vue')
        },
        {
            path: '/my-business',
            name: 'my-business',
            title: 'My Business',
            meta: { requiresAuth: true },
            component: () => import('../views/my-business/MyBusiness.vue')
        },
        {
            path: '/my-business/network/:alias/',
            name: 'my-business-network',
            title: 'My Business Terms',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, !store.getters.isRetrPermission),
            component: () => import('../views/my-business/network/Network.vue'),
            children: [
                {
                    path: 'retr',
                    name: 'my-business-retr',
                    title: 'My Business Retr',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => checkPermission(next, !store.getters.isRetrPermission),
                    component: () =>
                        import('../views/my-business/network/Retr.vue')
                },
                {
                    path: 'retr-current',
                    name: 'my-business-retr-current',
                    title: 'My Business Retr Current',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => checkPermission(next, !store.getters.isRetrPermission),
                    component: () =>
                        import('../views/my-business/network/RetrCurrent.vue')
                },
                {
                    path: ':newsId',
                    name: 'my-business-terms',
                    title: 'My Business Terms',
                    meta: { requiresAuth: true },
                    beforeEnter: (to, from, next) => checkPermission(next, true),
                    component: () =>
                        import('../views/my-business/network/Terms.vue')
                }
            ]
        },
        {
            path: '/my-business/retr/:alias/complaints',
            name: 'reclamations',
            title: 'Complaints',
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => checkPermission(next, !store.getters.isRetrPermission),
            component: () => import('../views/my-business/network/Reclamations.vue')

        },
        {
            path: '/my-business/newsletters',
            name: 'newsletters',
            title: 'Newsletters',
            meta: { requiresAuth: true },
            component: () => import('../views/my-business/Newsletters.vue')
        },
        {
            path: '/my-business/newsletters/:id',
            name: 'newsletter-details',
            title: 'NewsletterDetails',
            meta: { requiresAuth: true },
            component: () =>
                import('../views/my-business/NewsletterDetails.vue')
        },
        {
            path: '/my-business/announcements',
            name: 'announcements',
            title: 'Announcements',
            meta: { requiresAuth: true },
            component: () => import('../views/my-business/Announcements.vue')
        },
        {
            path: '/my-business/newspaper_materials',
            name: 'newspaper-materials',
            title: 'Newspaper Materials',
            meta: { requiresAuth: true },
            component: () =>
                import('../views/my-business/marketing/NewspaperMaterials.vue')
        },
        {
            path: '/merchant_notification_promo_attachments',
            name: 'merchant-notification-promo-attachments',
            title: 'Merchant Notification Promo Attachments',
            meta: { requiresAuth: false },
            component: () => import('../views/FileDownload.vue')
        },
        {
            path: '/help',
            name: 'help',
            title: 'Help',
            meta: { requiresAuth: true },
            component: () => import('../views/settings/Help.vue')
        },
        {
            path: '/drs',
            name: 'drs',
            title: 'System Kaucyjny',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/Drs.vue')
        },
        {
            path: '/drs/operators',
            name: 'drs-operators',
            title: 'Drs Operators',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/operators/OperatorsList.vue')
        },
        {
            path: '/drs/operators/:id',
            name: 'drs-operator-details',
            title: 'Drs Operator Details',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/operators/OperatorDetails.vue')
        },
        {
            path: '/drs/stores',
            name: 'drs-stores',
            title: 'Drs Stores',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/stores/Stores.vue'),
            children: [
                {
                    path: 'configuration',
                    name: 'drs-stores-configuration',
                    title: 'Drs Stores Configuration',
                    meta: { requiresAuth: true },
                    component: () =>
                        import('../views/drs/stores/Configuration.vue')
                },
                {
                    path: 'summary',
                    name: 'drs-stores-summary',
                    title: 'Drs Stores Summary',
                    meta: { requiresAuth: true },
                    component: () =>
                        import('../views/drs/stores/Summary.vue')
                },
                {
                    path: 'licenses',
                    name: 'drs-stores-licenses',
                    title: 'Drs Stores Licenses',
                    meta: { requiresAuth: true },
                    component: () =>
                        import('../views/drs/stores/Licenses.vue')
                },
                {
                    path: 'bags',
                    name: 'drs-stores-bags',
                    title: 'Drs Stores Bags',
                    meta: { requiresAuth: true },
                    component: () =>
                        import('../views/drs/stores/Bags.vue')
                }
            ]
        },
        {
            path: '/drs/integrations',
            name: 'drs-integrations',
            title: 'Drs Integrations',
            meta: { requiresAuth: true },
            component: () =>
                import('../views/drs/stores/Integrations.vue')
        },
        {
            path: '/drs/reports',
            name: 'drs-reports',
            title: 'Drs Reports',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/reports/Reports.vue')
        },
        {
            path: '/drs/reports/used-coupons',
            name: 'drs-used-coupons-report',
            title: 'Drs Used Coupons Report',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/reports/UsedCouponsReport.vue')
        },
        {
            path: '/drs/settings',
            title: 'Drs Settings',
            meta: { requiresAuth: true },
            component: () => import('../views/drs/settings/Settings.vue'),
            children: [
                {
                    path: '',
                    redirect: { name: 'drs-payment' }
                },
                {
                    path: 'payment',
                    name: 'drs-payment',
                    title: 'Drs Payment',
                    meta: { requiresAuth: true },
                    component: () => import('../views/drs/payment/Payment.vue')
                },
                {
                    path: 'consents',
                    name: 'drs-consents',
                    title: 'Drs Consents',
                    meta: { requiresAuth: true },
                    component: () => import('../views/drs/settings/Consents.vue')
                }
            ]
        },
        {
            path: '*',
            component: () => import('../views/NotFound.vue')
        }
    ],
    checkShopRouteNames: [
        'promo-list',
        'promo-yours',
        'promo-later',
        'promo-finished',
        'promo-details',
        'labels'
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 1 }
    }
})

let count = 0
router.beforeEach((to, from, next) => {
    // download merchant notification attachments
    if (to.path === '/merchant_notification_promo_attachments') {
        const { id, token } = JSON.parse(JSON.stringify(to.query))
        const payload = { id, token }

        if (!id || !token) {
            router.push('/')
            return
        }

        store.dispatch('fetchMerchantPromoAttachments', payload).then(() => {
            setTimeout(() => {
                router.push('/')
            }, 1000)
        })
        next()
    }

    // meta description
    let metaDesc = document.querySelector('meta[name="description"]')
    if (to.meta.description) {
        if (!metaDesc) {
            metaDesc = document.createElement('meta')
            metaDesc.name = 'description'
            metaDesc.content = to.meta.description
            document.head.appendChild(metaDesc)
        } else {
            metaDesc.content = to.meta.description
        }
    } else if (metaDesc) {
        metaDesc.remove()
    }

    const recaptchaBadge = document.getElementsByClassName('grecaptcha-badge')
    if (recaptchaBadge[0]) {
        if (to.name === 'login') {
            recaptchaBadge[0].style.visibility = 'visible'
        } else {
            recaptchaBadge[0].style.visibility = 'hidden'
        }
    }

    router.count = count++

    if (to.path === '/cart') {
        router.push('/promo-list')
    }

    // logout
    if (to.name === 'logout') {
        store.dispatch('authRemove').then(() => {
            store.dispatch('clearAddNewPromoForm')
            next({ name: 'login' })
        })
    }

    // check auth routes
    if (to.meta.requiresAuth) {
        store
            .dispatch('authCheckTokenValidity')
            .then(() => {
                next()
            })
            .catch(err => {})
    } else {
        next()
    }

    if (to.path === '/') {
        store
            .dispatch('authCheckTokenValidity')
            .then(() => {
                router.push('/dashboard')
            })
            .catch(err => {})
    }

    if (to.path === '/login') {
        if (to.query.token) {
            const loginByToken = async () => {
                await store.dispatch('authRemove')
                store.dispatch('authLogin', {
                    endpoint: 'loginByToken',
                    requestBody: { token: to.query.token }
                })
            }
            loginByToken()
        }

        if (to.query.hash) {
            const loginByHash = async () => {
                await store.dispatch('authRemove')
                store.dispatch('loginByHash', to.query.hash)
            }
            loginByHash()
            return
        }

        store
            .dispatch('authCheckTokenValidity')
            .then(() => {
                router.push('/dashboard')
            })
            .catch(err => {})
    }

    if (to.path.includes('/link')) {
        store
            .dispatch('getGeneratedLink', to.path.split('/').slice(-1)[0])
            .then(() => {
                store.dispatch('authCheckTokenValidity').then(() => {
                    if (
                        store.getters.isLogged &&
                        store.getters.getGeneratedLink
                    ) {
                        store.dispatch('goToGeneratedLink')
                    } else {
                        router.push({ name: 'login' })
                    }
                })
            })
    }

    if (
        router.options.checkShopRouteNames.some(v => to.name?.includes(v)) &&
        store.getters.isShopUser
    ) {
        store.dispatch('merchantsFetch')
    }

    if (to.path.includes('/drs')) {
        registerPageModule(store, DrsStore, 'drs')
        registerPageModule(store, DrsTariffs, 'drsTariffs')
    }
})

router.afterEach(async (to, from) => {
    if (to.path === '/privacy-policy') {
        await router.push('/login')
        store.dispatch('openModal', {
            component: 'ModalCookies'
        })
    }
    setTimeout(() => {
        store.dispatch('handleExpandedGroup', {
            to
        })
    }, 0)
})

function checkPermission(
    next,
    isShopUserPermissionDenied,
    brandPermissionPath
) {
    if (brandPermissionPath) {
        let brandPermissionValue = Vue.prototype.$brand
        brandPermissionPath.split('.').forEach(v => {
            brandPermissionValue = brandPermissionValue[v]
        })
        if (
            (brandPermissionValue && brandPermissionValue.isHidden) ||
            (store.getters.isShopUser && isShopUserPermissionDenied)
        ) {
            router.push({ name: 'permission-denied' })
        } else {
            next()
        }
    } else if (store.getters.isShopUser && isShopUserPermissionDenied) {
        router.push({ name: 'permission-denied' })
    } else {
        next()
    }
}

export default router
